import { upperFirst } from 'lodash';

export default class LoginViewState {
  static isPrototypeInitialized = false;

  buildWithMethods() {
    if (!LoginViewState.isPrototypeInitialized) {
      const proto = Object.getPrototypeOf(this); // eslint-disable-line prefer-reflect
      for (const field in this) {
        if (this.hasOwnProperty(field)) {
          proto[`with${upperFirst(field)}`] = function (value) {
            return this.copyWith(field, value);
          };
        }
      }

      LoginViewState.isPrototypeInitialized = true;
    }
  }

  constructor(
    isEmailFormVisible = false,
    isBackToEmailButtonVisible = false,
    isBackToSignInButtonVisible = false,
    isLoginHintEmailDisplayVisible = false,
    isForgotPasswordButtonVisible = false,
    isErrorVisible = false,
    headingText = null,
    subheadingText = null,
    subcontextText = null,
    email = null,
    federatedConnection = null,
    lockState = null
  ) {
    this.isEmailFormVisible = isEmailFormVisible;
    this.isBackToEmailButtonVisible = isBackToEmailButtonVisible;
    this.isBackToSignInButtonVisible = isBackToSignInButtonVisible;
    this.isLoginHintEmailDisplayVisible = isLoginHintEmailDisplayVisible;
    this.isForgotPasswordButtonVisible = isForgotPasswordButtonVisible;
    this.isErrorVisible = isErrorVisible;
    this.headingText = headingText;
    this.subheadingText = subheadingText;
    this.subcontextText = subcontextText;
    this.email = email;
    this.federatedConnection = federatedConnection;
    this.lockState = lockState;

    this.buildWithMethods();
  }

  copyWith(field, value) {
    const result = new LoginViewState(
      this.isEmailFormVisible,
      this.isBackToEmailButtonVisible,
      this.isBackToSignInButtonVisible,
      this.isLoginHintEmailDisplayVisible,
      this.isForgotPasswordButtonVisible,
      this.isErrorVisible,
      this.headingText,
      this.subheadingText,
      this.subcontextText,
      this.email,
      this.federatedConnection,
      this.lockState
    );
    result[field] = value;
    return result;
  }

  withText(text) {
    return this.withHeadingText(text.heading)
      .withSubheadingText(text.subheading)
      .withSubcontextText(text.subcontext);
  }
}
